import { LinearProgress } from '@mui/material';
import React from 'react';
import { styled } from '@mui/material/styles';

import './CommonLinearProgress.scss';

function CommonLinearProgress({ progress }) {
  return (
    <div className='common-linear-progress_wrapper'>
      <StyledLinearProgress variant='determinate' value={progress} />
    </div>
  );
}

export default CommonLinearProgress;

const StyledLinearProgress = styled(LinearProgress)({
  borderRadius: 4,
  backgroundColor: 'var(--button-secondary)',
  '& .MuiLinearProgress-bar': {
    backgroundColor: 'var(--color-primary)',
  },
});
